module.exports = __webpack_public_path__ + "img/tabbed-vehicle-rows-mazda.f58800ca.png";